// /admin/config — real route. Mirrors apps/web's app/admin/config/page.tsx:
// fully self-contained 'use client' page (fetches/patches /api/admin/config,
// no route params), lazy-imported directly per the porting convention
// (route-helpers.tsx). Registered from routes/admin.tsx under the `_admin`
// guard (routes/guards.tsx), parity with app/admin/layout.tsx:6.
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { adminRoute } from './guards';

const AdminConfigPage = lazy(() => import('@/app/admin/config/page'));

export const adminConfigRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: '/admin/config',
  component: AdminConfigPage,
});
